import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Card,
  CardContent,
  Typography,
  LinearProgress,
  Switch,
  Button,
  Divider,
} from "@mui/material";
import { Wifi, Shield, Lightbulb } from "lucide-react";
import DashboardHeader from "../Dashboard/DashboardHeader";
import { useSelector } from "react-redux";
import {
  ApplicationType,
  entity_id,
  getGeolocation,
  location,
  Platform,
} from "../Utils/Const";
import { baseapi } from "../Environmentalurl";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import useIPAddress from "../Utils/useIPAddress";
import api from "../Utils/Api";

const formatMaskedCard = (card) => {
  if (!card || card.length < 8) {
    return "●●●● ●●●● ●●●● ●●●●";
  }

  const last4 = card.slice(-4);
  return `●●●● ●●●● ●●●● ${last4}`;
};

const ExpenseCard = ({ title, limit, percent, amount, color }) => (
  <Card sx={{ borderRadius: 4, boxShadow: 3 }}>
    <CardContent>
      <Box display="flex" justifyContent="space-between">
        <Typography variant="body2" color="text.secondary">
          Limit: {percent}%
        </Typography>
        <Typography fontWeight="bold">Rs.{amount}.00</Typography>
      </Box>
      <Typography mt={1} fontWeight="600">
        {title}
      </Typography>
      <LinearProgress
        variant="determinate"
        value={percent}
        sx={{
          mt: 2,
          height: 6,
          borderRadius: 5,
          backgroundColor: "#e0e0e0",
          "& .MuiLinearProgress-bar": {
            backgroundColor: color,
          },
        }}
      />
    </CardContent>
  </Card>
);

const WalletCard = ({ title, gradient, maskedCard }) => {
  const navigate = useNavigate();
  const handleManageClick = () => {
    let type = "";

    switch (title.toLowerCase()) {
      case "food & dining":
        type = "food";
        break;
      case "travel":
        type = "travel";
        break;
      case "fuel card":
        type = "fuel";
        break;
      case "telecom":
        type = "telecom";
        break;
      default:
        type = "general";
    }
    navigate(`/dashboard/expensemanagement/${type}`);
  };

  return (
    <Card
      sx={{
        borderRadius: 5,
        color: "white",
        background: gradient,
        boxShadow: 4,
      }}
    >
      <CardContent>
        <Box display="flex" justifyContent="space-between">
          <Typography variant="caption" letterSpacing={2}>
            {title}
          </Typography>
        </Box>

        <Box mt={4}>
          <Typography variant="h6" letterSpacing={3}>
            {formatMaskedCard(maskedCard)}
          </Typography>
        </Box>

        <Box
          mt={3}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography variant="caption">VALID THRU 12/28</Typography>

          <Button
            size="small"
            variant="contained"
            onClick={handleManageClick}
            sx={{
              borderRadius: 3,
              textTransform: "none",
              backgroundColor: "rgba(255,255,255,0.2)",
            }}
          >
            Manage
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
};

const TransactionItem = ({ title, category, amount }) => (
  <Box py={2}>
    <Box display="flex" justifyContent="space-between">
      <Box>
        <Typography fontWeight="600">{title}</Typography>
        <Typography variant="body2" color="text.secondary">
          {category}
        </Typography>
      </Box>
      <Box textAlign="right">
        <Typography fontWeight="600">-{amount}</Typography>
        <Typography variant="caption" color="green">
          COMPLETED
        </Typography>
      </Box>
    </Box>
    <Divider sx={{ mt: 2 }} />
  </Box>
);

export default function Homepage() {
  const [maskedCard, setMaskedCard] = useState("");

  const ip = useIPAddress();
  const [user, setUser] = useState({});
  const [subWallet, setSubWallet] = useState({
    General: 0,
    Food: 0,
    Fuel: 0,
    Telecom: 0,
  });

  const Mobilenumber = JSON.parse(
    sessionStorage.getItem("mobileNumber") || "null",
  );
  const rupayRefNo = useSelector((state) => state.auth.rupayRefNo);
  console.log("rupayRefNo" + rupayRefNo);
  const SessionID = JSON.parse(sessionStorage.getItem("SessionID") || "null");
  useEffect(() => {
    if (!rupayRefNo) return;

    const payload = {
      ReqType: "Jan_Aadhaar_eWallet_GetCardStatus",
      Mobilenumber: Mobilenumber,
      ReferenceNumber: rupayRefNo,
      Platform: Platform,
      ApplicationType: ApplicationType,
      EntityID: entity_id,
      GeoLocation: location,
      MachineID: ip,
      SessionID: SessionID,
    };

    axios
      .post(`${baseapi}/getcardstatus`, payload)
      .then((res) => {
        if (res.data.Response_Code === "4001") {
          setMaskedCard(res.data.MaskedCard);
        }
      })
      .catch((err) => console.log(err));
  }, [rupayRefNo]);

  useEffect(() => {
    const fetchBalanceEnquiry = async () => {
      try {
        const payload = {
          ApplicationType: "1",
          EntityID: entity_id,
          GeoLocation: location,
          MachineID: ip,
          Mobilenumber: sessionStorage.getItem("mobileNumber"),
          Platform: Platform,
          ReqType: "Jan_Aadhaar_eWallet_Balance_Enquiry",
          SessionID: sessionStorage.getItem("SessionID") || "",
        };

        const response = await api.post(
          `${baseapi}/JanAadhaareWalletBalanceEnquiry`,
          payload,
        );

        if (response.data.Response_Code === "1000") {
          const walletData = response.data.SubWallets?.[0];
          setSubWallet(
            walletData || {
              General: 0,
              Food: 0,
              Fuel: 0,
              Telecom: 0,
            },
          );
          setUser((prev) => ({
            ...prev,
            Balance: response.data.Balance,
            LedgerBalance: response.data.LedgerBalance,
            NameOnCard: prev.NameOnCard || "User Name",
            UPIVPA: prev.UPIVPA || "user@upi",
            Is_KYC_Done: prev.Is_KYC_Done || "1",
          }));
          setSubWallet(walletData);
        } else {
          console.error("Balance Enquiry Failed:", response.data.Message);
        }
      } catch (error) {
        console.error("API call error:", error);
      }
    };

    fetchBalanceEnquiry();
  }, [location.search]);
  return (
    <>
      <DashboardHeader />
      <Box sx={{ backgroundColor: "#f5f6f8", minHeight: "100vh", p: 4 }}>
        <Box display="flex" justifyContent="space-between" mb={4}>
          <Box>
            <Typography variant="h5" fontWeight="700">
              Expense Cards
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Manage your category-specific spending limits and cards.
            </Typography>
          </Box>
        </Box>

        <Grid container spacing={3}>
          <Grid size={{ xs: 12, md: 3 }} item xs={12} md={3}>
            <ExpenseCard
              title="General Wallet"
              percent={100}
              amount={subWallet.General}
              color="#6366f1"
            />
          </Grid>

          <Grid size={{ xs: 12, md: 3 }} item xs={12} md={3}>
            <ExpenseCard
              title="Food Card"
              percent={70}
              amount={subWallet.Food}
              color="#22c55e"
            />
          </Grid>

          <Grid size={{ xs: 12, md: 3 }} item xs={12} md={3}>
            <ExpenseCard
              title="Fuel Card"
              percent={45}
              amount={subWallet.Fuel}
              color="#f97316"
            />
          </Grid>

          <Grid size={{ xs: 12, md: 3 }} item xs={12} md={3}>
            <ExpenseCard
              title="Telecom Card"
              percent={12}
              amount={subWallet.Telecom}
              color="#06b6d4"
            />
          </Grid>
        </Grid>

        <Typography variant="h6" mt={6} mb={3} fontWeight="700">
          Virtual Wallets
        </Typography>

        <Grid container spacing={3}>
          <Grid size={{ xs: 12, md: 3 }} item xs={12} md={3}>
            <WalletCard
              title="FOOD & DINING"
              gradient="linear-gradient(135deg,#16a34a,#059669)"
              maskedCard={maskedCard}
            />
          </Grid>
          <Grid size={{ xs: 12, md: 3 }} item xs={12} md={3}>
            <WalletCard
              title="TRAVEL"
              gradient="linear-gradient(135deg,#6d28d9,#4c1d95)"
              maskedCard={maskedCard}
            />
          </Grid>
          <Grid size={{ xs: 12, md: 3 }} item xs={12} md={3}>
            <WalletCard
              title="FUEL CARD"
              gradient="linear-gradient(135deg,#ca8a04,#eab308)"
              maskedCard={maskedCard}
            />
          </Grid>
          <Grid size={{ xs: 12, md: 3 }} item xs={12} md={3}>
            <WalletCard
              title="TELECOM"
              gradient="linear-gradient(135deg,#334155,#1e3a8a)"
              maskedCard={maskedCard}
            />
          </Grid>
        </Grid>

        <Grid container spacing={4} mt={4}>
          <Grid size={{ xs: 12, md: 8 }} item xs={12} md={8}>
            <Card sx={{ borderRadius: 4, p: 2 }}>
              <Typography fontWeight="700" mb={2}>
                Category Transactions
              </Typography>
              <TransactionItem
                title="Zomato Order"
                category="Food"
                amount="450.00"
              />
              <TransactionItem
                title="HP Petrol Pump"
                category="Fuel"
                amount="1,200.00"
              />
              <TransactionItem
                title="Uber Ride"
                category="Travel"
                amount="180.50"
              />
              <TransactionItem
                title="Airtel Recharge"
                category="Telecom"
                amount="499.00"
              />
              <TransactionItem
                title="Indigo Flight"
                category="Travel"
                amount="5,600.00"
              />
            </Card>
          </Grid>

          <Grid size={{ xs: 12, md: 4 }} item xs={12} md={4}>
            <Card
              sx={{
                borderRadius: 4,
                p: 3,
                backgroundColor: "#0f172a",
                color: "white",
              }}
            >
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <Typography fontWeight="700">Card Security</Typography>
                <Shield size={18} />
              </Box>

              <Box
                mt={3}
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <Typography>Contactless Payment</Typography>
                <Switch defaultChecked />
              </Box>

              <Box
                mt={2}
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <Typography>Online Transactions</Typography>
                <Switch defaultChecked />
              </Box>

              <Box
                mt={2}
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <Typography>ATM Withdrawal</Typography>
                <Switch />
              </Box>

              <Button
                fullWidth
                variant="contained"
                sx={{
                  mt: 4,
                  borderRadius: 3,
                  textTransform: "none",
                  backgroundColor: "#10b981",
                }}
              >
                Manage All Cards
              </Button>
            </Card>

            <Card sx={{ borderRadius: 4, p: 3, mt: 3 }}>
              <Box display="flex" alignItems="center" gap={1}>
                <Lightbulb size={18} />
                <Typography fontWeight="600">Tax Benefit</Typography>
              </Box>
              <Typography variant="body2" color="text.secondary" mt={1}>
                Save up to $3,000 on monthly food allowance with compliant
                receipts.
              </Typography>
            </Card>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}
